module.exports = __webpack_public_path__ + "static/china-business-news-77594219619695d74497e82581b57e50.svg";